import { RadioButtonFormElement } from './formElements/selects/RadioButtonFormElement';
import { InputTextFormElement } from './formElements/inputs/InputTextFormElement';
import { InputNumberFormElement } from './formElements/inputs/InputNumberFormElement';
import { AutocompleteDropdownFormElement } from './formElements/selects/AutocompleteDropdownFormElement';
import { DateInputSegmentedFormElement } from './formElements/dates/DateInputSegmentedFormElement';
import { DatePickerFormElement } from './formElements/dates/DatePickerFormElement';
import { SwitchFormElement } from './formElements/switches/SwitchFormElement';
import { ChipFormElement } from './formElements/selects/ChipFormElement';
import { ComponentsTypes } from '@/constants/componentsTypes';
import { Field } from '@/schemas/sceneDataSchema';
import { UseFormReturn } from 'react-hook-form';
import { InputPhoneFormElement } from './formElements/inputs/InputPhoneFormElement';
import { InputEmailFormElement } from './formElements/inputs/InputEmailFormElement';
import { encodeFieldKey } from '@/schemas/validation/ValidationSchemaGenerator';

import CheckboxFormElement from './formElements/checkboxes/CheckboxFormElement';
import RichTextCheckboxFormElement from './formElements/checkboxes/RichTextCheckboxFormElement';
import { SelectDropdownFormElement } from './formElements/selects/SelectDropdownFormElement';
import { BraintreePayment } from './braintree/BraintreePayment';

export function DynamicFormFieldRenderer({
  form,
  component,
}: {
  form: UseFormReturn | undefined | null;
  component: Field;
}) {
  if (form == null) {
    return <>Form is not found</>;
  }

  const renderElement = () => {
    switch (component.type) {
      case ComponentsTypes.BRAINTREE_INPUT:
        return (
          <BraintreePayment
            client_token={component.client_token}
            exclude_applepay={component.exclude_applepay}
            legal={component.legal}
            amount={component.amount}
            form={form}
            component={component}
          />
        );
      case ComponentsTypes.TEXT_INPUT:
        return (
          <InputTextFormElement
            form={form}
            component={component}
            key={encodeFieldKey(component)}
          />
        );
      case ComponentsTypes.NUMBER_INPUT:
        return (
          <InputNumberFormElement
            form={form}
            component={component}
            key={encodeFieldKey(component)}
          />
        );
      case ComponentsTypes.RADIO:
        return (
          <RadioButtonFormElement
            form={form}
            component={component}
            key={encodeFieldKey(component)}
          />
        );
      case ComponentsTypes.CHIP_GROUP:
        return (
          <ChipFormElement
            form={form}
            component={component}
            key={encodeFieldKey(component)}
          />
        );
      case ComponentsTypes.AUTOCOMPLETE_DROPDOWN:
        return (
          <AutocompleteDropdownFormElement
            form={form}
            component={component}
            key={encodeFieldKey(component)}
          />
        );
      case ComponentsTypes.SELECT_DROPDOWN:
        return (
          <SelectDropdownFormElement
            form={form}
            component={component}
            key={encodeFieldKey(component)}
          />
        );
      case ComponentsTypes.DATE_INPUT_SEGMENTED:
        return (
          <DateInputSegmentedFormElement
            key={encodeFieldKey(component)}
            form={form}
            component={component}
          />
        );
      case ComponentsTypes.DATE_PICKER:
        return (
          <DatePickerFormElement
            key={encodeFieldKey(component)}
            form={form}
            component={component}
          />
        );
      case ComponentsTypes.SWITCH:
        return (
          <SwitchFormElement
            key={encodeFieldKey(component)}
            form={form}
            component={component}
          />
        );
      case ComponentsTypes.CHECKBOX:
        return (
          <CheckboxFormElement
            key={encodeFieldKey(component)}
            form={form}
            component={component}
          />
        );
      case ComponentsTypes.RICH_TEXT_CHECKBOX:
        return (
          <RichTextCheckboxFormElement
            key={encodeFieldKey(component)}
            form={form}
            component={component}
          />
        );
      case ComponentsTypes.EMAIL_INPUT:
        return (
          <InputEmailFormElement
            form={form}
            component={component}
            key={encodeFieldKey(component)}
          />
        );
      case ComponentsTypes.PHONE_INPUT:
        return (
          <InputPhoneFormElement
            form={form}
            component={component}
            key={encodeFieldKey(component)}
          />
        );
      default:
        return <>Component is not found</>;
    }
  };

  return renderElement();
}
